import React from 'react';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import QuickShopOptionType from './QuickShopOptionType';
import QuickShopOptionValue from './QuickShopOptionValue';

export default class PodCountOptions extends React.Component {
  static propTypes = {
    variants: propTypes.array.isRequired,
    selectedVariant: accountPropTypes.ProductVariant,
    changeSelectedVariant: propTypes.func.isRequired,
  };

  availableOptionValues = optionType => {
    return [...new Set(this.props.variants.map(v => v[optionType]))]
      .sort()
      .reverse();
  };

  podCountOptionTypeTitle = () => {
    return <TranslatedMessage id={'cart.quick_shop.pod_pack_size'} />;
  };

  optionValueLabel = podCount => {
    return (
      <TranslatedMessage
        id={'cart.quick_shop.pack_size'}
        values={{ pod_count: podCount }}
      />
    );
  };

  getPendingVariant = podCount => {
    return this.props.variants.find(
      v =>
        v.nicotineStrength === this.props.selectedVariant.nicotineStrength &&
        v.podCount === podCount
    );
  };

  render() {
    const { selectedVariant, changeSelectedVariant, variants } = this.props;
    const optionType = 'podCount';

    const podCountOptionValues = this.availableOptionValues(optionType).map(
      (optionValue, index) => (
        <QuickShopOptionValue
          key={optionType + index}
          optionValue={optionValue}
          optionValueLabel={this.optionValueLabel(optionValue)}
          optionType={optionType}
          variants={variants}
          selectedVariant={selectedVariant}
          changeSelectedVariant={changeSelectedVariant}
          pendingVariant={this.getPendingVariant(optionValue)}
        />
      )
    );

    // podCount is a string from the backend
    const podCount = parseInt(this.props.selectedVariant.podCount, 10);

    return (
      <QuickShopOptionType title={this.podCountOptionTypeTitle()}>
        {podCountOptionValues}
        <div className="input__helper-text">
          {podCount === 2 && (
            <TranslatedMessage id={'cart.quick_shop.two_packs_not_available'} />
          )}
        </div>
      </QuickShopOptionType>
    );
  }
}
